export const RANKING_FONT = "system-ui, sans-serif";

// Restyle the existing success/fail colors without assigning meaning by series index.
// Custom server colors remain intact, including charts with more than two series.
const SERIES_COLORS: Record<string, { fill: string; text: string }> = {
	"#4caf50": { fill: "#3f9f69", text: "#277c4a" },
	"#f44336": { fill: "#d96a77", text: "#b74353" },
	"#19a361": { fill: "#3f9f69", text: "#277c4a" },
	"#c5003e": { fill: "#d96a77", text: "#b74353" },
};

export const rankingSeriesColor = (color: string, part: "fill" | "text" = "fill") => SERIES_COLORS[color.trim().toLowerCase()]?.[part] ?? color;
